<!--SKU编辑  -->
<template>
	<div class="dialogBox">
		<el-dialog title="合并路线" :visible.sync="dialogVisible" :close-on-click-modal="false"
			:close-on-press-escape="false" :modal-append-to-body="false" width="1000px" :before-close="cancle" top="3vh">
			<div class="merge-content">
				<div class="icon-size">
					源路线：<i class="el-icon-circle-plus-outline ml10" @click="handleAddMerge('Y')"></i><i
						class="el-icon-remove-outline ml15" @click="handleDelete"></i>
				</div>
				<el-divider></el-divider>
				<el-table v-if="tableData.length>0" :data="tableData" @selection-change="handleSelectionChange"
					:header-cell-style="{background:'#C8CCD7',color:'#333333',height:'25px'}" border
					style="width: 100%">
					<el-table-column type="selection" width="55">
					</el-table-column>
					<el-table-column v-show="tableData" v-for="(value, index) in titles" :key="index"
						:show-overflow-tooltip="true" :label="value.title" :min-width="value.maxWidth">
						<template slot-scope="scope">
							{{scope.row.datas[index]}}
						</template>
					</el-table-column>
				</el-table>
				<div v-else class="tc mt15">暂无数据</div>
				<div class="icon-size mt15">
					目标路线:<i class="el-icon-circle-plus-outline ml10" @click="handleAddMerge('N')"></i><i
						class="el-icon-remove-outline ml15" @click="handleDeleteNc"></i>
				</div>
				<el-divider></el-divider>
				<el-table v-if="tableData1.length>0" :data="tableData1"
					:header-cell-style="{background:'#C8CCD7',color:'#333333',height:'25px'}" border
					style="width: 100%">
					<el-table-column v-show="tableData1" v-for="(value, index) in titles1" :key="index"
						:show-overflow-tooltip="true" :label="value.title" :min-width="value.maxWidth">
						<template slot-scope="scope">
							{{scope.row.datas[index]}}
						</template>
					</el-table-column>
				</el-table>
				<div v-else class="tc mt15">暂无数据</div>
			</div>
			<span slot="footer" class="dialog-footer mt10">
				<el-button size="small" @click="cancle()">取 消</el-button>
				<el-button size="small" type="primary" @click="submitForm()">合并</el-button>
			</span>
		</el-dialog>
		<addRoute ref="addRoute" @selectRows="selectRows" @titles="getTitles" @selectNewFlag="selectNewFlag"></addRoute>
		<routeEdit ref="routeEdit"></routeEdit>
	</div>
</template>

<script>
	import addRoute from './add-route.vue'
	import routeEdit from './route-edit.vue'
	import {
		debounce
	} from '@/utils/debounce'
	export default {
		components: {
			addRoute,
			routeEdit
		},
		data() {
			return {
				dialogVisible: false,
				agentIds: [],
				tableData: [],
				titles: [],
				ncCode: "",
				tableData1: [],
				titles1: [],
				multipleSelection: [],
				otherTable: [], //临时table,
				otherTitle: [], //临时table,
			}
		},
		created() {

		},
		methods: {
			init() {
				this.$nextTick(() => {
					this.dialogVisible = true
					this.tableData = []
					this.tableData1 = []
				})
			},
			//  添加客商信息
			handleAddMerge(val) {
				this.$nextTick(() =>{
					if (val == "Y" && this.tableData.length >= 10) {
						this.$message.error('只能添加10条源路线!');
						return
					}
					this.$refs.addRoute.init(val == 'Y' ? this.tableData : this.tableData1, val)
				})
				
			},

			// 删除目标客商
			handleDeleteNc() {
				this.tableData1 = []
			},
			// 列多选
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			// 删除
			handleDelete() {
				let that = this;
				if (that.multipleSelection.length <= 0) {
					this.$message.error('请先选择!');
					return
				}
				that.multipleSelection.forEach((ele) => {
					that.tableData.forEach((item, index, arr) => {
						if (item.dataKey == ele.dataKey) {
							arr.splice(index, 1); //删除下标为i的元素
						}
					});
				});
				this.$forceUpdate()
			},
			// 选择的客商信息
			selectRows(val) {
				this.otherTable = val
			},
			//
			getTitles(val) {
				this.otherTitle = val
			},
			// 判断是哪个表返回的数据
			selectNewFlag(val) {
				if (val == "Y") {
					this.titles = this.otherTitle
					this.tableData = this.unRepeat(this.otherTable, this.tableData)
				} else {
					this.titles1 = this.otherTitle
					this.tableData1 = this.otherTable
				}
			},
			// 去重
			unRepeat(json1, json2) {
				let json = json1.concat(json2); //两个数组对象合并
				console.log(json)
				let newJson = []; //盛放去重后数据的新数组
				json.forEach(item1 => {
					let flag = true; //建立标记，判断数据是否重复，true为不重复
					newJson.forEach(item2 => {
						if (item1.dataKey == item2.dataKey) { //让json数组对象的内容与新数组的内容作比较，相同的话，改变标记为false
							flag = false;
						}
					});
					if (flag) { //判断是否重复
						newJson.push(item1); //不重复的放入新数组。  新数组的内容会继续进行上边的循环。
					}
				});
				return newJson
			},
			// 保存
			submitForm: debounce(function () {
				let that = this;
				if (that.tableData.length <= 0) {
					that.$message.error('请选择路线!');
					return
				}
				if (that.tableData1.length <= 0) {
					that.$message.error('请选择目标路线!');
					return
				}
				let routeIds = []
				that.tableData.forEach(item => {
					routeIds.push(item.dataKey)
				});

				that.$confirm('确认要合并路线，把源路线的客商信息合并到目标路线里吗？', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					that.$request.post(
							"routeMergeAgent",
							true, {
								routeIds: routeIds,
								toRouteId: that.tableData1[0].dataKey,
							}
						)
						.then((res) => {
							if (res) {
								that.dialogVisible = false
								that.$message.success("合并成功！");
								that.$emit("getList")
								that.$refs.routeEdit.init(that.tableData1[0])
							}
						})
				}).catch(() => {});
			}, 1000, true),
			// 取消
			cancle() {
				this.dialogVisible = false
			},
		},
		beforeDestroy() {

		}
	}

</script>
<style lang='scss' scoped>
	.dialogBox {

		/deep/ .el-dialog__body {
			padding: 15px;
		}

		.el-table {

			// 深度选择器，去除默认的padding
			/deep/ th {
				padding: 5px;
			}

			/deep/ td {
				padding: 5px;
			}
		}

		.el-divider--horizontal {
			margin: 15px 0;
		}
	}

	.icon-size {
		font-size: 16px;
	}

</style>
